(function() {
  'use strict';

  var ABOUT_ATTR = 'data-cb-about';

  /* ── Scroll-triggered reveal ── */
  function initReveal() {
    var els = document.querySelectorAll('[' + ABOUT_ATTR + '-reveal]');
    if (!els.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('cb-about-revealed');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

    els.forEach(function(el) { observer.observe(el); });
  }

  /* ── Animated stat counters ── */
  function initCounters() {
    var counters = document.querySelectorAll('[' + ABOUT_ATTR + '-counter]');
    if (!counters.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var target = parseInt(el.getAttribute(ABOUT_ATTR + '-counter'), 10);
          if (isNaN(target)) { el.textContent = el.textContent; return; }
          animateCounter(el, target);
          observer.unobserve(el);
        }
      });
    }, { threshold: 0.5 });

    counters.forEach(function(el) { observer.observe(el); });
  }

  function animateCounter(el, target) {
    var duration = 1800;
    var start = performance.now();
    var suffix = el.getAttribute(ABOUT_ATTR + '-suffix') || '';

    function step(now) {
      var progress = Math.min((now - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = Math.round(eased * target);
      el.textContent = current + suffix;
      if (progress < 1) {
        requestAnimationFrame(step);
      } else {
        // Add pulse animation when counter completes
        el.classList.add('cb-about-counter-done');
      }
    }
    requestAnimationFrame(step);
  }

  /* ── Sticky section nav ── */
  function initStickyNav() {
    var nav = document.querySelector('[' + ABOUT_ATTR + '-nav]');
    var sections = document.querySelectorAll('[' + ABOUT_ATTR + '-section]');
    if (!nav || !sections.length) return;

    var links = nav.querySelectorAll('a');
    var sectionTops = [];

    function updatePositions() {
      sectionTops = [];
      sections.forEach(function(s) {
        sectionTops.push(s.offsetTop - 120);
      });
    }

    updatePositions();
    window.addEventListener('resize', updatePositions);

    var scrollObserver = new IntersectionObserver(function() {
      var scrollY = window.scrollY;
      var active = 0;
      for (var i = sectionTops.length - 1; i >= 0; i--) {
        if (scrollY >= sectionTops[i]) { active = i; break; }
      }
      links.forEach(function(link, idx) {
        link.classList.toggle('cb-about-nav-active', idx === active);
      });
    }, { threshold: [0, 0.25, 0.5, 0.75, 1] });

    sections.forEach(function(s) { scrollObserver.observe(s); });

    links.forEach(function(link) {
      link.addEventListener('click', function(e) {
        e.preventDefault();
        var target = document.querySelector(this.getAttribute('href'));
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  }

  /* ── Testimonial carousel ── */
  function initCarousel() {
    var track = document.querySelector('[' + ABOUT_ATTR + '-carousel]');
    if (!track) return;
    var slides = track.children;
    if (slides.length < 2) return;

    var current = 0;
    var prevBtn = document.querySelector('[' + ABOUT_ATTR + '-carousel-prev]');
    var nextBtn = document.querySelector('[' + ABOUT_ATTR + '-carousel-next]');
    var dots = document.querySelectorAll('[' + ABOUT_ATTR + '-carousel-dot]');

    function show(idx) {
      current = (idx + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      if (dots.length) {
        dots.forEach(function(d, i) {
          d.classList.toggle('cb-about-dot-active', i === current);
        });
      }
    }

    if (prevBtn) prevBtn.addEventListener('click', function() { show(current - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { show(current + 1); });
    dots.forEach(function(dot) {
      dot.addEventListener('click', function() { show(parseInt(this.dataset.index, 10)); });
    });

    show(0);
  }

  /* ── Supply chain animation ── */
  function initSupplyChain() {
    var chain = document.querySelector('[' + ABOUT_ATTR + '-chain]');
    if (!chain) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          chain.classList.add('cb-about-chain-animated');
          observer.unobserve(chain);
        }
      });
    }, { threshold: 0.3 });

    observer.observe(chain);
  }

  /* ── Micro-interactions: card tilt ── */
  function initTilt() {
    var cards = document.querySelectorAll('[' + ABOUT_ATTR + '-tilt]');
    cards.forEach(function(card) {
      card.addEventListener('mousemove', function(e) {
        var rect = card.getBoundingClientRect();
        var x = (e.clientX - rect.left) / rect.width - 0.5;
        var y = (e.clientY - rect.top) / rect.height - 0.5;
        card.style.transform = 'perspective(600px) rotateY(' + (x * 6) + 'deg) rotateX(' + (-y * 6) + 'deg) translateY(-4px)';
      });
      card.addEventListener('mouseleave', function() {
        card.style.transform = 'perspective(600px) rotateY(0deg) rotateX(0deg) translateY(0px)';
      });
    });
  }

  /* ── Init all ── */
  function init() {
    initReveal();
    initCounters();
    initStickyNav();
    initCarousel();
    initSupplyChain();
    initTilt();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();